import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, href, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-8 py-4 text-sm font-medium transition-all duration-300 rounded-full tracking-wide uppercase shadow-sm hover:shadow-md active:scale-95 hover:-translate-y-0.5";
  const variants = {
    primary: "bg-taupe-400 text-white hover:bg-taupe-500",
    secondary: "bg-white text-stone-900 border border-stone-200 hover:border-stone-900 hover:bg-taupe-50",
    outline: "border border-stone-300 text-stone-600 hover:border-stone-900 hover:text-stone-900 hover:bg-stone-50",
    dark: "bg-stone-900 text-white hover:bg-stone-800",
  };

  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;

  if (to) {
    return <Link to={to} className={combinedClassName} {...props}>{children}</Link>;
  }

  if (href) {
    return <a href={href} className={combinedClassName} {...props}>{children}</a>;
  }

  return (
    <button className={combinedClassName} {...props}>
      {children}
    </button>
  );
};

export default Button;
